import React, { useState } from 'react';
import useComponentDidMount from 'Hooks/useComponentDidMount';

export default function useProcessingProgress() {
  const progressIntervalRef = React.useRef(null);
  const [progress, setProgress] = useState(0);

  useComponentDidMount(() => {
    progressIntervalRef.current = setInterval(
      () => {
        setProgress((prev) => {
          return prev === 100 ? 0 : prev + 1;
        });
      }, 100,
    );
  }, () => {
    clearInterval(progressIntervalRef.current);
  });

  return progress;
}
